export default function Footer(){
    
    return (
        <footer className="j-footer">
            &#169; 2023 Jana Veliskova
            
        </footer>
    )
}
